import React, { Component } from "react";

import axios from "axios";
import Constants from "../App/Variables/Constants";
import {
  Backdrop,
  Button,
  Container,
  Fade,
  Grid,
  Modal,
  TextField,
  Typography,
  Snackbar,
} from "@material-ui/core";
import init from "../helpers/WindowToken";
import EditIcon from "@material-ui/icons/Edit";
import { Redirect, Link } from "react-router-dom";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { Form } from "reactstrap";
import { makeStyles } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
let fd =  new FormData();

const classes = makeStyles();

export default class Update_Testimonial extends Component {
  state = {
    _id: "",
    title: "",
    description: "",
    loading: false,
    message: "",
    notification: false,
    redirect: false,
  };

  componentDidMount() {
    let id = window.location.pathname.split("/")[3];
    let data = this.props.location.state.data;
    this.setState({
      _id: id,
      title: data.name,
      description: data.content,
      image: data.image,
    });
  }

  updatePlay = (e) => {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    fd.append("name", this.state.title);
    fd.append("content", this.state.description);
    fd.append("image", this.state.image);

    if (init() === "success") {
      axios
        .put(Constants.putUrls.updateTestimonial  + this.state._id, fd)
        .then((res) => {
          console.log(res);
          this.setState({
            loading: false,
            notification: true,
          });
          setTimeout(() => {
            this.setState({
              notification: false,
              redirect: true,
            });
          }, 2000);
        });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleFile = (e) => {
    this.setState({
      [e.target.name]: e.target.files[0],
    });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/testimonial" />;
    } else {
      return (
        <Container maxWidth="xl">
          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              open={true}
              color={"green"}
              autoHideDuration={6000}
              message="Updated Successfully"
            ></Snackbar>
          ) : null}
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h6">
                {this.props.title}Update Testimonial
              </Typography>
            </Grid>
          </Grid>
          {/* {this.state.notification ? (
            <Snackbar
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              open={true}
              color={"green"}
              autoHideDuration={6000}
              message={this.state.message}
            ></Snackbar>
          ) : null} */}
          <div
            style={{
              background: "#5b5757",
              padding: "20px",
              borderRadius: "10px",
              // color: rgba(0, 0, 0, 0.87);
              width: "100%",
              border: "0",
              display: "flex",
              position: "relative",
              fontSize: ".875rem",
              minWidth: "0",
              wordWrap: " break-word",
              /* background: #FFF; */
              boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
              marginTop: "30px",
              borderRadius: "6px",
              marginBottom: "30px",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
                boxShadow:
                  " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
                float: "left",
                padding: "15px",
                marginTop: "-43px",
                marginRight: "15px",
                borderRadius: "3px",
                backgroundColor: "#999",
                width: "6%",
                height: "60px",
                marginBottom: "25px",
                textAlign: "center",
              }}
            >
              <EditIcon />
            </div>
           
            <Grid item sm={12} style={{ textAlign: "left", marginTop: "30px" }}>
              <Form onSubmit={this.updatePlay}>
                <TextField
                  id="outlined-basic"
                  onChange={this.handleInput}
                  label="Title"
                  name="title"
                  variant="outlined"
                  value={this.state.title}
                  // required={true}
                  style={{
                    marginRight: "20px",
                    width: "30%",
                    marginBottom: "20px",
                  }}
                />
                <div>
                  <label>Upload Image</label>
                  <br />
                  <input
                    id="image"
                    name="image"
                    onChange={this.handleFile}
                    accept="image/*"
                    type="file"
                    // required={true}
                    style={{ marginTop: "15px" }}
                  />
                </div>
                {/* <TextField
                  id="outlined-basic"
                  onChange={this.handleInput}
                  // label="Description"
                  name="description"
                  variant="outlined"
                  value={this.state.description}
                  // required={true}
                  style={{
                    marginRight: "20px",
                    width: "30%",
                    marginBottom: "20px",
                  }}
                /> */}

                <br />
                <Button
                  variant="contained"
                  type="submit"
                  Size={15}
                  color="primary"
                  style={{ marginRight: "20px", marginTop: "35px" }}
                >
                  {this.state.loading ? "Updating.." : "Update"}
                </Button>
                <Link
                  to={{
                    pathname: "/testimonial",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    Size={15}
                    color="secondary"
                    style={{ marginRight: "20px", marginTop: "35px" }}
                  >
                    Cancel
                  </Button>
                </Link>
              </Form>
            </Grid>
          </div>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={this.state.open}
            onClose={this.handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500,
            }}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Fade in={this.state.open}>
              <div
                style={{
                  background: "#fff",
                  width: "50%",
                  padding: "32px",
                }}
              >
                <h2 id="transition-modal-title">Transition modal</h2>
                <p id="transition-modal-description">
                  react-transition-group animates me.
                </p>
              </div>
            </Fade>
          </Modal>
        </Container>
      );
    }
  }
}
